<template>
  <div class="main">
    <a-card class="lists" hoverable>
      <div>
        <a-input-search
          style="margin:8px 0"
          placeholder="输入关键词搜索"
          v-model="searchValue"
          @change="onChange"
          @keyup.esc="cleanSearch()"
        />
      </div>
      <div class="catalist" style="width:320px;">
        <a-tree
          :expanded-keys="expandedKeys"
          :auto-expand-parent="autoExpandParent"
          :tree-data="treeData"
          :replace-fields="{ key: 'catid' }"
          @expand="onExpand"
          @select="clickCate"
          :defaultSelectedKeys="['-1']"
        >
          <template slot="title" slot-scope="{ title, intro }">
            <span :title="intro.substr(1)">
              <span v-if="title.indexOf(searchValue) > -1">
                {{ title.substr(0, title.indexOf(searchValue)) }}
                <span style="color: #f50">{{ searchValue }}</span>
                {{
                  title.substr(title.indexOf(searchValue) + searchValue.length)
                }}
              </span>
              <span v-else>{{ title }}</span>
            </span>
            <span v-show="searchValue" style="font-size:12px;color:#999;"
              >({{ intro.substr(1) }})</span
            >
          </template>
        </a-tree>
      </div>
    </a-card>
    <div class="detail">
      <ListTable
        :catid="catid"
        @getdetails="getdetails"
        ref="table"
      ></ListTable>
    </div>
    <div>
      <Preview
        :catesingle="catesingle"
        :articleId="articleId"
        :articleVis="articleVis"
        :catid="catid"
        @close="close"
        @reset="reset"
      ></Preview>
    </div>
  </div>
</template>

<script>
import ListTable from './ListTable';
import Preview from './preview';
export default {
  name: 'Lists',
  components: { ListTable, Preview },
  data() {
    return {
      searchValue: '',
      oldtreeData: [],
      tempObj: [],
      expandedKeys: [],
      treeData: [],
      autoExpandParent: true,
      valueTree: undefined,
      catid: 0,
      catesingle: [],
      articleId: 0,
      articleVis: false
    };
  },
  created() {},
  mounted() {
    this.getCateList();
  },
  methods: {
    getCateList() {
      this.$http
        .post('/api/content/categorylist', { limit: 9999 })
        .then(res => {
          let data = res.data.data;
          data.unshift({
            catid: '-1',
            catname: '全部文章',
            ctype: '123',
            linkurl: '',
            parentid: '0'
          });
          let list = this.toTree(data);
          this.treeData = this.treeKey(list);
          this.catesingle = data;
          this.oldtreeData = JSON.parse(JSON.stringify(this.treeData));
          let firstData = this.oldtreeData[0];
          function first(arr) {
            for (let i in arr) {
              if (arr[i].children) {
                first(arr[i].children);
              } else {
                return arr.catid;
              }
            }
          }
          this.catid = first(firstData);
        });
    },

    cleanSearch() {
      this.onChange('c');
    },
    deepSearch(tree) {
      this.tempObj = [];
      var stark = [];
      stark = stark.concat(tree);
      while (stark.length) {
        var temp = stark.shift();
        if (temp.children) {
          stark = temp.children.concat(stark);
        }
        this.tempObj.push(temp);
      }
    },
    onChange(e) {
      if (typeof e == 'string') {
        this.searchValue = '';
        this.treeData = this.oldtreeData;
      } else {
        const value = e.target.value;
        if (value != '') {
          let tempObj = [];
          this.deepSearch(this.oldtreeData);
          for (let item of this.tempObj) {
            if (item.title.indexOf(value) >= 0) {
              if (typeof item[item.catid] == 'undefined') {
                tempObj.push(item);
              }
            }
          }
          this.treeData = tempObj;
        } else {
          this.treeData = this.oldtreeData;
        }
      }
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    toTree(data) {
      data.forEach(item => {
        delete item.children;
      });
      let map = {};
      data.forEach(item => {
        item.scopedSlots = { title: 'title' };
        map[item.catid] = item;
      });
      let val = [];
      data.forEach(item => {
        let parent = map[item.parentid];
        if (parent) {
          (parent.children || (parent.children = [])).push(item);
        } else {
          val.push(item);
        }
      });
      return val;
    },
    treeKey(data) {
      let val = [];
      let that = this;
      function setName(obj, ide, intro) {
        for (let i = 0; i < obj.length; i++) {
          obj[i].title = obj[i].catname;
          obj[i].key = ide + '-' + i;
          obj[i].intro = intro + '>' + obj[i].catname;
          obj[i].value = obj[i].catid;
          obj[i].label = obj[i].catname;
          if (obj[i].children) {
            obj[i].disabled = true;
          }
          if (obj[i].children) {
            that.expandedKeys.push(obj[i].catid);
            setName(obj[i].children, obj[i].key, obj[i].intro);
          }
        }
        val = obj;
      }
      setName(data, '0', '');
      return val;
    },
    clickCate(value) {
      if (value.length > 0) {
        this.catid = value[0];
      } else {
        this.catid = 0;
      }
    },
    getdetails(id) {
      this.articleVis = true;
      this.articleId = id;
    },
    close() {
      this.articleVis = false;
    },
    reset() {
      this.$refs.table.getLists();
    }
  }
};
</script>

<style scoped>
.wrap {
  position: relative;
}
.caret {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 6px dashed;
  border-right: 6px dashed;
  border-bottom: 6px solid transparent;
  border-left: 6px solid transparent;
}
.primary {
  border-top-color: #1890ff;
  border-right-color: #1890ff;
}
.gray {
  border-top-color: #d9d9d9;
  border-right-color: #d9d9d9;
}
.main {
  position: absolute;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  background-color: #fff;
  /*padding-top:10px*/
}

.lists {
  width: 360px;
  position: absolute;
  padding: 0 10px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: scroll;
}
.row {
  padding: 5px;
  min-height: 80px;
  line-height: 24px;
  border-bottom: 1px solid #e8e8e8;
}
.current {
  background-color: #409eff;
}

.active,
.active > .pubtime,
.active > .user {
  color: #fff;
}

.row .title {
  font-size: 16px;
  min-height: 50px;
}

.row .title i {
  margin-right: 5px;
}

.row .info {
  font-size: 13px;
  height: 24px;
  line-height: 24px;
  color: #c0c4cc;
}

.row .info .pubtime {
  text-align: left;
}
.row .info .user {
  text-align: right;
}

.detail {
  position: absolute;
  left: 370px;
  right: 0;
  top: 0;
  bottom: 10px;
  overflow-y: auto;
}
.detail .toolbar {
  text-align: right;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #e8e8e8;
}
.detail .toolbar i {
  margin-right: 5px;
}

.detail .toolbar .menu {
  float: right;
  cursor: pointer;
  text-align: center;
  height: 50px;
  line-height: 50px;
  width: 70px;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}

.catelists {
  max-height: 300px;
  overflow: hidden;
  overflow-y: auto;
}

.cate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 10px;
  text-align: left;
  /*height: 38px;*/
  line-height: 38px;
}
.cate:hover {
  background: #eeeeee;
}

.dropdown-key {
  max-height: 600px;
  overflow: hidden;
  overflow-y: auto;
  width: 800px;
}

code {
  margin: 0 1px;
  background: #f2f4f5;
  padding: 0.2em 0.4em;
  border-radius: 3px;
  font-size: 0.9em;
  color: #7e7e7e;
  border: 1px solid #eee;
}
</style>
